module.exports = __webpack_public_path__ + "img/63ne.b727861c.svg";